import {
  GET_GENERAL_SETTINGS_FAILED,
  GET_GENERAL_SETTINGS_INIT,
  GET_GENERAL_SETTINGS_SUCCESS,
  UPDATE_GENERAL_SETTINGS_INIT,
  UPDATE_GENERAL_SETTINGS_SUCCESS,
  UPDATE_GENERAL_SETTINGS_FAILED,
  GET_ROLES_INIT,
  GET_ROLES_SUCCESS,
  GET_ROLES_FAILED,
  GET_SKILLS_INIT,
  GET_SKILLS_SUCCESS,
  GET_SKILLS_FAILED,
  GET_ADMIN_DEPARTMENTS_INIT,
  GET_ADMIN_DEPARTMENTS_SUCCESS,
  GET_ADMIN_DEPARTMENTS_FAILED,
  UPDATE_ROLES_INIT,
  UPDATE_ROLES_SUCCESS,
  UPDATE_ROLES_FAILED,
  UPDATE_SKILLS_INIT,
  UPDATE_SKILLS_SUCCESS,
  UPDATE_SKILLS_FAILED,
  UPDATE_DEPARTMENTS_INIT,
  UPDATE_DEPARTMENTS_SUCCESS,
  UPDATE_DEPARTMENTS_FAILED,
  GET_MANAGERS_INIT,
  GET_MANAGERS_SUCCESS,
  GET_MANAGERS_FAILED,
  GET_PRIORITIES_INIT,
  GET_PRIORITIES_SUCCESS,
  GET_PRIORITIES_FAILED,
  GET_PROJECT_TYPES_INIT,
  GET_PROJECT_TYPES_SUCCESS,
  GET_PROJECT_TYPES_FAILED,
  GET_PM_COMPONENTS_SETTINGS_INIT,
  GET_PM_COMPONENTS_SETTINGS_SUCCESS,
  GET_PM_COMPONENTS_SETTINGS_FAILED,
  GET_RM_COMPONENTS_SETTINGS_INIT,
  GET_RM_COMPONENTS_SETTINGS_SUCCESS,
  GET_RM_COMPONENTS_SETTINGS_FAILED,
  GET_FM_COMPONENTS_SETTINGS_INIT,
  GET_FM_COMPONENTS_SETTINGS_SUCCESS,
  GET_FM_COMPONENTS_SETTINGS_FAILED,
  UPDATE_PM_COMPONENTS_SETTINGS_INIT,
  UPDATE_PM_COMPONENTS_SETTINGS_SUCCESS,
  UPDATE_PM_COMPONENTS_SETTINGS_FAILED,
  UPDATE_RM_COMPONENTS_SETTINGS_INIT,
  UPDATE_RM_COMPONENTS_SETTINGS_SUCCESS,
  UPDATE_RM_COMPONENTS_SETTINGS_FAILED,
  UPDATE_FM_COMPONENTS_SETTINGS_INIT,
  UPDATE_FM_COMPONENTS_SETTINGS_SUCCESS,
  UPDATE_FM_COMPONENTS_SETTINGS_FAILED,
  GET_PM_FIELDS_SETTINGS_INIT,
  GET_PM_FIELDS_SETTINGS_SUCCESS,
  GET_PM_FIELDS_SETTINGS_FAILED,
  GET_RM_FIELDS_SETTINGS_INIT,
  GET_RM_FIELDS_SETTINGS_SUCCESS,
  GET_RM_FIELDS_SETTINGS_FAILED,
  UPDATE_PM_FIELDS_SETTINGS_INIT,
  UPDATE_PM_FIELDS_SETTINGS_SUCCESS,
  UPDATE_PM_FIELDS_SETTINGS_FAILED,
  UPDATE_RM_FIELDS_SETTINGS_INIT,
  UPDATE_RM_FIELDS_SETTINGS_SUCCESS,
  UPDATE_RM_FIELDS_SETTINGS_FAILED,
  GET_DIRECT_EMPLOYEE_DETAILS_INIT,
  GET_DIRECT_EMPLOYEE_DETAILS_SUCCESS,
  GET_DIRECT_EMPLOYEE_DETAILS_FAILED,
  GET_OTHER_DIRECT_INHOUSE_COST_INIT,
  GET_OTHER_DIRECT_INHOUSE_COST_SUCCESS,
  GET_OTHER_DIRECT_INHOUSE_COST_FAILED,
  GET_VENDOR_EMPLOYEE_DETAILS_INIT,
  GET_VENDOR_EMPLOYEE_DETAILS_SUCCESS,
  GET_VENDOR_EMPLOYEE_DETAILS_FAILED,
  GET_VENDOR_RELATED_COST_INIT,
  GET_VENDOR_RELATED_COST_SUCCESS,
  GET_VENDOR_RELATED_COST_FAILED,
  GET_CAPEX_RELATED_EXPENSES_INIT,
  GET_CAPEX_RELATED_EXPENSES_SUCCESS,
  GET_CAPEX_RELATED_EXPENSES_FAILED,
  UPDATE_DIRECT_EMPLOYEE_DETAILS_INIT,
  UPDATE_DIRECT_EMPLOYEE_DETAILS_SUCCESS,
  UPDATE_DIRECT_EMPLOYEE_DETAILS_FAILED,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_INIT,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_SUCCESS,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_FAILED,
  UPDATE_VENDOR_EMPLOYEE_DETAILS_INIT,
  UPDATE_VENDOR_EMPLOYEE_DETAILS_SUCCESS,
  UPDATE_VENDOR_EMPLOYEE_DETAILS_FAILED,
  UPDATE_VENDOR_RELATED_COST_INIT,
  UPDATE_VENDOR_RELATED_COST_SUCCESS,
  UPDATE_VENDOR_RELATED_COST_FAILED,
  UPDATE_CAPEX_RELATED_EXPENSES_INIT,
  UPDATE_CAPEX_RELATED_EXPENSES_SUCCESS,
  UPDATE_CAPEX_RELATED_EXPENSES_FAILED,
  GET_EMPLOYEE_TYPES_LIST_INIT,
  GET_EMPLOYEE_TYPES_LIST_SUCCESS,
  GET_EMPLOYEE_TYPES_LIST_FAILED,
  GET_PROJECT_STATUS_LIST_INIT,
  GET_PROJECT_STATUS_LIST_SUCCESS,
  GET_PROJECT_STATUS_LIST_FAILED,
  GET_FINANCIAL_MANAGEMENT_SETTINGS_INIT,
  GET_FINANCIAL_MANAGEMENT_SETTINGS_SUCCESS,
  GET_FINANCIAL_MANAGEMENT_SETTINGS_FAILED,
  UPDATE_FINANCIAL_MANAGEMENT_SETTINGS_INIT,
  UPDATE_FINANCIAL_MANAGEMENT_SETTINGS_SUCCESS,
  UPDATE_FINANCIAL_MANAGEMENT_SETTINGS_FAILED,
  GET_LOCATION_SETTINGS_INIT,
  GET_LOCATION_SETTINGS_SUCCESS,
  GET_LOCATION_SETTINGS_FAILED,
  UPDATE_LOCATION_SETTINGS_INIT,
  UPDATE_LOCATION_SETTINGS_SUCCESS,
  UPDATE_LOCATION_SETTINGS_FAILED,
  LOGIN_INIT,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  LOGOUT_INIT,
  LOGOUT_SUCCESS,
  LOGOUT_FAILED,
  GET_DELEGATED_DEPARTMENT_HISTORY_INIT,
  GET_DELEGATED_DEPARTMENT_HISTORY_SUCCESS,
  GET_DELEGATED_DEPARTMENT_HISTORY_FAILED,
  GET_DELEGATION_RESOURCE_LIST_INIT,
  GET_DELEGATION_RESOURCE_LIST_SUCCESS,
  GET_DELEGATION_RESOURCE_LIST_FAILED,
  GET_DELEGATION_RESOURCE_FROM_LIST_INIT,
  GET_DELEGATION_RESOURCE_FROM_LIST_SUCCESS,
  GET_DELEGATION_RESOURCE_FROM_LIST_FAILED,
  CREATE_DELEGATE_DEPARTMENT_INIT,
  CREATE_DELEGATE_DEPARTMENT_SUCCESS,
  CREATE_DELEGATE_DEPARTMENT_FAILED,
  NEW_USER_REGISTRATION_INIT,
  NEW_USER_REGISTRATION_SUCCESS,
  NEW_USER_REGISTRATION_FAILED,
  GET_DOWNLOAD_CREATE_ROLE_TEMPLATE_EXCEL_INIT,
  GET_DOWNLOAD_CREATE_ROLE_TEMPLATE_EXCEL_SUCCESS,
  GET_DOWNLOAD_CREATE_ROLE_TEMPLATE_EXCEL_FAILED,
  CREATE_ROLE_FROM_EXCEL_INIT,
  CREATE_ROLE_FROM_EXCEL_SUCCESS,
  CREATE_ROLE_FROM_EXCEL_FAILED,
  DOWNLOAD_CREATE_DEPARTMENT_TEMPLATE_EXCEL_FILE_INIT,
  DOWNLOAD_CREATE_DEPARTMENT_TEMPLATE_EXCEL_FILE_SUCCESS,
  DOWNLOAD_CREATE_DEPARTMENT_TEMPLATE_EXCEL_FILE_FAILED,
  CREATE_DEPARTMENT_FROM_EXCEL_INIT,
  CREATE_DEPARTMENT_FROM_EXCEL_SUCCESS,
  CREATE_DEPARTMENT_FROM_EXCEL_FAILED,
  GET_SSO_RESULT_INIT,
  GET_SSO_RESULT_SUCCESS,
  GET_SSO_RESULT_FAILED,
  GET_EMAIL_SETTINGS_INIT,
  GET_EMAIL_SETTINGS_SUCCESS,
  GET_EMAIL_SETTINGS_FAILED,
  UPDATE_EMAIL_SETTINGS_INIT,
  UPDATE_EMAIL_SETTINGS_SUCCESS,
  UPDATE_EMAIL_SETTINGS_FAILED,
  USER_ACCESS_REPORT_INIT,
  USER_ACCESS_REPORT_SUCCESS,
  USER_ACCESS_REPORT_FAILED,
  DOWNLOAD_USER_ACCESS_REPORT_INIT,
  DOWNLOAD_USER_ACCESS_REPORT_SUCCESS,
  DOWNLOAD_USER_ACCESS_REPORT_FAILED,
  GET_ACTIVITIES_INIT,
  GET_ACTIVITIES_SUCCESS,
  GET_ACTIVITIES_FAILED,
  SAVE_ACTIVITIES_INIT,
  SAVE_ACTIVITIES_SUCCESS,
  SAVE_ACTIVITIES_FAILED,
  GET_SUBJECTS_INIT,
  GET_SUBJECTS_SUCCESS,
  GET_SUBJECTS_FAILED,
  SAVE_SUBJECTS_INIT,
  SAVE_SUBJECTS_SUCCESS,
  SAVE_SUBJECTS_FAILED,
  DOWNLOAD_ACTIVITIES_INIT,
  DOWNLOAD_ACTIVITIES_SUCCESS,
  DOWNLOAD_ACTIVITIES_FAILED,
  DOWNLOAD_SUBJECTS_INIT,
  DOWNLOAD_SUBJECTS_SUCCESS,
  DOWNLOAD_SUBJECTS_FAILED,
  DOWNLOAD_DEPARTMENTS_INIT,
  DOWNLOAD_DEPARTMENTS_SUCCESS,
  DOWNLOAD_DEPARTMENTS_FAILED,
  GET_USER_DEFAULT_SETTINGS_INIT,
  GET_USER_DEFAULT_SETTINGS_SUCCESS,
  GET_USER_DEFAULT_SETTINGS_FAILED,
  SAVE_USER_DEFAULT_SETTINGS_INIT,
  SAVE_USER_DEFAULT_SETTINGS_SUCCESS,
  SAVE_USER_DEFAULT_SETTINGS_FAILED,
  GET_USER_ACCESS_CHART_INIT,
  GET_USER_ACCESS_CHART_SUCCESS,
  GET_USER_ACCESS_CHART_FAILED,
} from "./types/admin-types";
import {
  getGeneralSettingsAPI,
  updateGeneralSettingsAPI,
  getRolesAPI,
  getSkillsAPI,
  getAdminDepartmentsAPI,
  updateRolesAPI,
  updateDepartmentsAPI,
  updateSkillsAPI,
  getPrioritiesListAPI,
  getReportingManagersAPI,
  getProjectTypesListAPI,
  getPMComponentSettingsAPI,
  updatePMComponentSettingsAPI,
  getPMFieldSettingsAPI,
  updatePMFieldSettingsAPI,
  getRMComponentSettingsAPI,
  updateRMComponentSettingsAPI,
  getRMFieldSettingsAPI,
  updateRMFieldSettingsAPI,
  getFMComponentSettingsAPI,
  updateFMComponentSettingsAPI,
  getDirectEmployeeDetailsAPI,
  updateDirectEmployeeDetailsAPI,
  getOtherDirectInhouseCostAPI,
  updateOtherDirectInhouseCostAPI,
  getVendorEmployeeDetailsAPI,
  updateVendorEmployeeDetailsAPI,
  getVendorRelatedCostAPI,
  updateVendorRelatedCostAPI,
  getCapexRelatedExpenseAPI,
  updateCapexRelatedExpenseAPI,
  getEmploymentTypeListAPI,
  getProjectStatusListAPI,
  getFinanceMgmtSettingsAPI,
  updateFinanceMgmtSettingsAPI,
  getGeneralSettingsLocationAPI,
  updateGeneralSettingsLocationAPI,
  loginAPI,
  logoutAPI,
  getDelegatedResourceHistoryAPI,
  getResourceListForDelegationAPI,
  createDelegatedResourceHistoryAPI,
  newUserRegistrationAPI,
  downloadCreateRoleTemplateExcelFileAPI,
  createRoleFromExcelAPI,
  downloadCreateDepartmentTemplateExcelFileAPI,
  createDepartmentFromExcelAPI,
  getResourceListForDelegationFromRoleAPI,
  getSSODataAPI,
  getEmailSettingsAPI,
  updateEmailSettingsAPI,
  getUserAccessReportAPI,
  downloadUserAccessReportAPI,
  getActivityMasterSettingsAPI,
  saveActivityMasterSettingsAPI,
  getSubjectMasterSettingsAPI,
  saveSubjectMasterSettingsAPI,
  downloadActivityMasterAPI,
  downloadSubjectMasterAPI,
  downloadDepartmentDetailsExcelFileAPI,
  getUserDefaultSettingAPI,
  createUpdateUserDefaultSettingAPI,
  getUserAccessReportChartAPI,
} from "../api/admin-api";

export function getGeneralSettings() {
  return (dispatch) => {
    dispatch({ type: GET_GENERAL_SETTINGS_INIT });
    getGeneralSettingsAPI()
      .then((response) =>
        dispatch({ type: GET_GENERAL_SETTINGS_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: GET_GENERAL_SETTINGS_FAILED, error }));
  };
}

export function updateGeneralSettings(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_GENERAL_SETTINGS_INIT });
    updateGeneralSettingsAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_GENERAL_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_GENERAL_SETTINGS_FAILED, error })
      );
  };
}

export function getRoles() {
  return (dispatch) => {
    dispatch({ type: GET_ROLES_INIT });
    getRolesAPI()
      .then((response) => dispatch({ type: GET_ROLES_SUCCESS, response }))
      .catch((error) => dispatch({ type: GET_ROLES_FAILED, error }));
  };
}

export function getAdminDepartments() {
  return (dispatch) => {
    dispatch({ type: GET_ADMIN_DEPARTMENTS_INIT });
    getAdminDepartmentsAPI()
      .then((response) =>
        dispatch({ type: GET_ADMIN_DEPARTMENTS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_ADMIN_DEPARTMENTS_FAILED, error })
      );
  };
}

export function getSkills() {
  return (dispatch) => {
    dispatch({ type: GET_SKILLS_INIT });
    getSkillsAPI()
      .then((response) => dispatch({ type: GET_SKILLS_SUCCESS, response }))
      .catch((error) => dispatch({ type: GET_SKILLS_FAILED, error }));
  };
}

export function updateRoles(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_ROLES_INIT });
    updateRolesAPI(body)
      .then((response) => dispatch({ type: UPDATE_ROLES_SUCCESS, response }))
      .catch((error) => dispatch({ type: UPDATE_ROLES_FAILED, error }));
  };
}

export function updateDepartments(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_DEPARTMENTS_INIT });
    updateDepartmentsAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_DEPARTMENTS_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: UPDATE_DEPARTMENTS_FAILED, error }));
  };
}

export function updateSkills(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SKILLS_INIT });
    updateSkillsAPI(body)
      .then((response) => dispatch({ type: UPDATE_SKILLS_SUCCESS, response }))
      .catch((error) => dispatch({ type: UPDATE_SKILLS_FAILED, error }));
  };
}

export function getPrioritiesList() {
  return (dispatch) => {
    dispatch({ type: GET_PRIORITIES_INIT });
    getPrioritiesListAPI()
      .then((response) => dispatch({ type: GET_PRIORITIES_SUCCESS, response }))
      .catch((error) => dispatch({ type: GET_PRIORITIES_FAILED, error }));
  };
}

export function getReportingManagers() {
  return (dispatch) => {
    dispatch({ type: GET_MANAGERS_INIT });
    getReportingManagersAPI()
      .then((response) => dispatch({ type: GET_MANAGERS_SUCCESS, response }))
      .catch((error) => dispatch({ type: GET_MANAGERS_FAILED, error }));
  };
}

export function getProjectTypesList() {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_TYPES_INIT });
    getProjectTypesListAPI()
      .then((response) =>
        dispatch({ type: GET_PROJECT_TYPES_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: GET_PROJECT_TYPES_FAILED, error }));
  };
}

export function getPMComponentSettings() {
  return (dispatch) => {
    dispatch({ type: GET_PM_COMPONENTS_SETTINGS_INIT });
    getPMComponentSettingsAPI()
      .then((response) =>
        dispatch({ type: GET_PM_COMPONENTS_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_PM_COMPONENTS_SETTINGS_FAILED, error })
      );
  };
}

export function getRMComponentSettings() {
  return (dispatch) => {
    dispatch({ type: GET_RM_COMPONENTS_SETTINGS_INIT });
    getRMComponentSettingsAPI()
      .then((response) =>
        dispatch({ type: GET_RM_COMPONENTS_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RM_COMPONENTS_SETTINGS_FAILED, error })
      );
  };
}

export function getFMComponentSettings() {
  return (dispatch) => {
    dispatch({ type: GET_FM_COMPONENTS_SETTINGS_INIT });
    getFMComponentSettingsAPI()
      .then((response) =>
        dispatch({ type: GET_FM_COMPONENTS_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_FM_COMPONENTS_SETTINGS_FAILED, error })
      );
  };
}

export function updatePMComponentSettings(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_PM_COMPONENTS_SETTINGS_INIT });
    updatePMComponentSettingsAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_PM_COMPONENTS_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_PM_COMPONENTS_SETTINGS_FAILED, error })
      );
  };
}

export function updateRMComponentSettings(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_RM_COMPONENTS_SETTINGS_INIT });
    updateRMComponentSettingsAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_RM_COMPONENTS_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_RM_COMPONENTS_SETTINGS_FAILED, error })
      );
  };
}

export function updateFMComponentSettings(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_FM_COMPONENTS_SETTINGS_INIT });
    updateFMComponentSettingsAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_FM_COMPONENTS_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_FM_COMPONENTS_SETTINGS_FAILED, error })
      );
  };
}

export function getPMFieldSettings() {
  return (dispatch) => {
    dispatch({ type: GET_PM_FIELDS_SETTINGS_INIT });
    getPMFieldSettingsAPI()
      .then((response) =>
        dispatch({ type: GET_PM_FIELDS_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_PM_FIELDS_SETTINGS_FAILED, error })
      );
  };
}

export function getRMFieldSettings() {
  return (dispatch) => {
    dispatch({ type: GET_RM_FIELDS_SETTINGS_INIT });
    getRMFieldSettingsAPI()
      .then((response) =>
        dispatch({ type: GET_RM_FIELDS_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_RM_FIELDS_SETTINGS_FAILED, error })
      );
  };
}

export function updatePMFieldSettings(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_PM_FIELDS_SETTINGS_INIT });
    updatePMFieldSettingsAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_PM_FIELDS_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_PM_FIELDS_SETTINGS_FAILED, error })
      );
  };
}

export function updateRMFieldSettings(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_RM_FIELDS_SETTINGS_INIT });
    updateRMFieldSettingsAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_RM_FIELDS_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_RM_FIELDS_SETTINGS_FAILED, error })
      );
  };
}

export function getDirectEmployeeDetails() {
  return (dispatch) => {
    dispatch({ type: GET_DIRECT_EMPLOYEE_DETAILS_INIT });
    getDirectEmployeeDetailsAPI()
      .then((response) =>
        dispatch({ type: GET_DIRECT_EMPLOYEE_DETAILS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_DIRECT_EMPLOYEE_DETAILS_FAILED, error })
      );
  };
}

export function getOtherDirectInhouseCost() {
  return (dispatch) => {
    dispatch({ type: GET_OTHER_DIRECT_INHOUSE_COST_INIT });
    getOtherDirectInhouseCostAPI()
      .then((response) =>
        dispatch({ type: GET_OTHER_DIRECT_INHOUSE_COST_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_OTHER_DIRECT_INHOUSE_COST_FAILED, error })
      );
  };
}

export function getVendorEmployeeDetails() {
  return (dispatch) => {
    dispatch({ type: GET_VENDOR_EMPLOYEE_DETAILS_INIT });
    getVendorEmployeeDetailsAPI()
      .then((response) =>
        dispatch({ type: GET_VENDOR_EMPLOYEE_DETAILS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_VENDOR_EMPLOYEE_DETAILS_FAILED, error })
      );
  };
}

export function getVendorRelatedCost() {
  return (dispatch) => {
    dispatch({ type: GET_VENDOR_RELATED_COST_INIT });
    getVendorRelatedCostAPI()
      .then((response) =>
        dispatch({ type: GET_VENDOR_RELATED_COST_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_VENDOR_RELATED_COST_FAILED, error })
      );
  };
}

export function getCapexRelatedExpense() {
  return (dispatch) => {
    dispatch({ type: GET_CAPEX_RELATED_EXPENSES_INIT });
    getCapexRelatedExpenseAPI()
      .then((response) =>
        dispatch({ type: GET_CAPEX_RELATED_EXPENSES_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_CAPEX_RELATED_EXPENSES_FAILED, error })
      );
  };
}

export function updateDirectEmployeeDetails(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_DIRECT_EMPLOYEE_DETAILS_INIT });
    updateDirectEmployeeDetailsAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_DIRECT_EMPLOYEE_DETAILS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_DIRECT_EMPLOYEE_DETAILS_FAILED, error })
      );
  };
}

export function updateOtherDirectInhouseCost(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_OTHER_DIRECT_INHOUSE_COST_INIT });
    updateOtherDirectInhouseCostAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_OTHER_DIRECT_INHOUSE_COST_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_OTHER_DIRECT_INHOUSE_COST_FAILED, error })
      );
  };
}

export function updateVendorEmployeeDetails(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_VENDOR_EMPLOYEE_DETAILS_INIT });
    updateVendorEmployeeDetailsAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_VENDOR_EMPLOYEE_DETAILS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_VENDOR_EMPLOYEE_DETAILS_FAILED, error })
      );
  };
}

export function updateVendorRelatedCost(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_VENDOR_RELATED_COST_INIT });
    updateVendorRelatedCostAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_VENDOR_RELATED_COST_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_VENDOR_RELATED_COST_FAILED, error })
      );
  };
}

export function updateCapexRelatedExpense(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_CAPEX_RELATED_EXPENSES_INIT });
    updateCapexRelatedExpenseAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_CAPEX_RELATED_EXPENSES_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_CAPEX_RELATED_EXPENSES_FAILED, error })
      );
  };
}

export function getEmploymentTypeList() {
  return (dispatch) => {
    dispatch({ type: GET_EMPLOYEE_TYPES_LIST_INIT });
    getEmploymentTypeListAPI()
      .then((response) =>
        dispatch({ type: GET_EMPLOYEE_TYPES_LIST_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_EMPLOYEE_TYPES_LIST_FAILED, error })
      );
  };
}

export function getProjectStatusList() {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_STATUS_LIST_INIT });
    getProjectStatusListAPI()
      .then((response) =>
        dispatch({ type: GET_PROJECT_STATUS_LIST_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_PROJECT_STATUS_LIST_FAILED, error })
      );
  };
}

export function getFinanceMgmtSettings() {
  return (dispatch) => {
    dispatch({ type: GET_FINANCIAL_MANAGEMENT_SETTINGS_INIT });
    getFinanceMgmtSettingsAPI()
      .then((response) =>
        dispatch({ type: GET_FINANCIAL_MANAGEMENT_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_FINANCIAL_MANAGEMENT_SETTINGS_FAILED, error })
      );
  };
}

export function updateFinanceMgmtSettings(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_FINANCIAL_MANAGEMENT_SETTINGS_INIT });
    updateFinanceMgmtSettingsAPI(body)
      .then((response) =>
        dispatch({
          type: UPDATE_FINANCIAL_MANAGEMENT_SETTINGS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_FINANCIAL_MANAGEMENT_SETTINGS_FAILED, error })
      );
  };
}

export function getGeneralSettingsLocation() {
  return (dispatch) => {
    dispatch({ type: GET_LOCATION_SETTINGS_INIT });
    getGeneralSettingsLocationAPI()
      .then((response) =>
        dispatch({ type: GET_LOCATION_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_LOCATION_SETTINGS_FAILED, error })
      );
  };
}

export function updateGeneralSettingsLocation(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_LOCATION_SETTINGS_INIT });
    updateGeneralSettingsLocationAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_LOCATION_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_LOCATION_SETTINGS_FAILED, error })
      );
  };
}

export function login(body, isAzure) {
  return (dispatch) => {
    dispatch({ type: LOGIN_INIT });
    loginAPI(body, isAzure)
      .then((response) => dispatch({ type: LOGIN_SUCCESS, response }))
      .catch((error) => dispatch({ type: LOGIN_FAILED, error }));
  };
}

export function logout() {
  return (dispatch) => {
    dispatch({ type: LOGOUT_INIT });
    logoutAPI()
      .then((response) => dispatch({ type: LOGOUT_SUCCESS, response }))
      .catch((error) => dispatch({ type: LOGOUT_FAILED, error }));
  };
}

export function getDelegatedResourceHistory() {
  return (dispatch) => {
    dispatch({ type: GET_DELEGATED_DEPARTMENT_HISTORY_INIT });
    getDelegatedResourceHistoryAPI()
      .then((response) =>
        dispatch({ type: GET_DELEGATED_DEPARTMENT_HISTORY_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_DELEGATED_DEPARTMENT_HISTORY_FAILED, error })
      );
  };
}

export function getResourceListForDelegation(startDate, endDate) {
  return (dispatch) => {
    dispatch({ type: GET_DELEGATION_RESOURCE_LIST_INIT });
    getResourceListForDelegationAPI(startDate, endDate)
      .then((response) =>
        dispatch({ type: GET_DELEGATION_RESOURCE_LIST_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_DELEGATION_RESOURCE_LIST_FAILED, error })
      );
  };
}

export function getResourceListForDelegationFromRole(startDate, endDate) {
  return (dispatch) => {
    dispatch({ type: GET_DELEGATION_RESOURCE_FROM_LIST_INIT });
    getResourceListForDelegationFromRoleAPI(startDate, endDate)
      .then((response) =>
        dispatch({ type: GET_DELEGATION_RESOURCE_FROM_LIST_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_DELEGATION_RESOURCE_FROM_LIST_FAILED, error })
      );
  };
}

export function createDelegatedResourceHistory(body) {
  return (dispatch) => {
    dispatch({ type: CREATE_DELEGATE_DEPARTMENT_INIT });
    createDelegatedResourceHistoryAPI(body)
      .then((response) =>
        dispatch({ type: CREATE_DELEGATE_DEPARTMENT_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: CREATE_DELEGATE_DEPARTMENT_FAILED, error })
      );
  };
}
export function newUserRegistration(body) {
  return (dispatch) => {
    dispatch({ type: NEW_USER_REGISTRATION_INIT });
    newUserRegistrationAPI(body)
      .then((response) =>
        dispatch({ type: NEW_USER_REGISTRATION_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: NEW_USER_REGISTRATION_FAILED, error })
      );
  };
}
export function downloadCreateRoleTemplateExcelFile() {
  return (dispatch) => {
    dispatch({ type: GET_DOWNLOAD_CREATE_ROLE_TEMPLATE_EXCEL_INIT });
    downloadCreateRoleTemplateExcelFileAPI()
      .then((response) =>
        dispatch({
          type: GET_DOWNLOAD_CREATE_ROLE_TEMPLATE_EXCEL_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_DOWNLOAD_CREATE_ROLE_TEMPLATE_EXCEL_FAILED,
          error,
        })
      );
  };
}
export function createRoleFromExcel(username) {
  return (dispatch) => {
    dispatch({ type: CREATE_ROLE_FROM_EXCEL_INIT });
    createRoleFromExcelAPI(username)
      .then((response) =>
        dispatch({ type: CREATE_ROLE_FROM_EXCEL_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: CREATE_ROLE_FROM_EXCEL_FAILED, error })
      );
  };
}
export function downloadCreateDepartmentTemplateExcelFile(body) {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_CREATE_DEPARTMENT_TEMPLATE_EXCEL_FILE_INIT });
    downloadCreateDepartmentTemplateExcelFileAPI(body)
      .then((response) =>
        dispatch({
          type: DOWNLOAD_CREATE_DEPARTMENT_TEMPLATE_EXCEL_FILE_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: DOWNLOAD_CREATE_DEPARTMENT_TEMPLATE_EXCEL_FILE_FAILED,
          error,
        })
      );
  };
}
export function createDepartmentFromExcel(username) {
  return (dispatch) => {
    dispatch({ type: CREATE_DEPARTMENT_FROM_EXCEL_INIT });
    createDepartmentFromExcelAPI(username)
      .then((response) =>
        dispatch({ type: CREATE_DEPARTMENT_FROM_EXCEL_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: CREATE_DEPARTMENT_FROM_EXCEL_FAILED, error })
      );
  };
}

export function getSSOData(id) {
  return (dispatch) => {
    dispatch({ type: GET_SSO_RESULT_INIT });
    getSSODataAPI(id)
      .then((response) => dispatch({ type: GET_SSO_RESULT_SUCCESS, response }))
      .catch((error) => dispatch({ type: GET_SSO_RESULT_FAILED, error }));
  };
}

export function getEmailSettings() {
  return (dispatch) => {
    dispatch({ type: GET_EMAIL_SETTINGS_INIT });
    getEmailSettingsAPI()
      .then((response) =>
        dispatch({ type: GET_EMAIL_SETTINGS_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: GET_EMAIL_SETTINGS_FAILED, error }));
  };
}

export function updateEmailSettings(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_EMAIL_SETTINGS_INIT });
    updateEmailSettingsAPI(body)
      .then((response) =>
        dispatch({ type: UPDATE_EMAIL_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_EMAIL_SETTINGS_FAILED, error })
      );
  };
}

export function getUserAccessReport(body) {
  return (dispatch) => {
    dispatch({ type: USER_ACCESS_REPORT_INIT });
    getUserAccessReportAPI(body)
      .then((response) =>
        dispatch({ type: USER_ACCESS_REPORT_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: USER_ACCESS_REPORT_FAILED, error }));
  };
}

export function downloadUserAccessReport(body) {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_USER_ACCESS_REPORT_INIT });
    downloadUserAccessReportAPI(body)
      .then((response) =>
        dispatch({ type: DOWNLOAD_USER_ACCESS_REPORT_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: DOWNLOAD_USER_ACCESS_REPORT_FAILED, error })
      );
  };
}

export function getActivityMasterSettings() {
  return (dispatch) => {
    dispatch({ type: GET_ACTIVITIES_INIT });
    getActivityMasterSettingsAPI()
      .then((response) => dispatch({ type: GET_ACTIVITIES_SUCCESS, response }))
      .catch((error) => dispatch({ type: GET_ACTIVITIES_FAILED, error }));
  };
}

export function getSubjectMasterSettings() {
  return (dispatch) => {
    dispatch({ type: GET_SUBJECTS_INIT });
    getSubjectMasterSettingsAPI()
      .then((response) => dispatch({ type: GET_SUBJECTS_SUCCESS, response }))
      .catch((error) => dispatch({ type: GET_SUBJECTS_FAILED, error }));
  };
}

export function saveActivityMasterSettings(body) {
  return (dispatch) => {
    dispatch({ type: SAVE_ACTIVITIES_INIT });
    saveActivityMasterSettingsAPI(body)
      .then((response) => dispatch({ type: SAVE_ACTIVITIES_SUCCESS, response }))
      .catch((error) => dispatch({ type: SAVE_ACTIVITIES_FAILED, error }));
  };
}

export function saveSubjectMasterSettings(body) {
  return (dispatch) => {
    dispatch({ type: SAVE_SUBJECTS_INIT });
    saveSubjectMasterSettingsAPI(body)
      .then((response) => dispatch({ type: SAVE_SUBJECTS_SUCCESS, response }))
      .catch((error) => dispatch({ type: SAVE_SUBJECTS_FAILED, error }));
  };
}

export function clearActivities() {
  return (dispatch) => {
    dispatch({ type: GET_ACTIVITIES_INIT });
  };
}

export function clearSubjects() {
  return (dispatch) => {
    dispatch({ type: GET_SUBJECTS_INIT });
  };
}

export function downloadActivityMaster() {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_ACTIVITIES_INIT });
    downloadActivityMasterAPI()
      .then((response) =>
        dispatch({ type: DOWNLOAD_ACTIVITIES_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: DOWNLOAD_ACTIVITIES_FAILED, error }));
  };
}

export function downloadSubjectMaster() {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_SUBJECTS_INIT });
    downloadSubjectMasterAPI()
      .then((response) =>
        dispatch({ type: DOWNLOAD_SUBJECTS_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: DOWNLOAD_SUBJECTS_FAILED, error }));
  };
}

export function downloadDepartmentDetailsExcelFile() {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_DEPARTMENTS_INIT });
    downloadDepartmentDetailsExcelFileAPI()
      .then((response) =>
        dispatch({ type: DOWNLOAD_DEPARTMENTS_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: DOWNLOAD_DEPARTMENTS_FAILED, error }));
  };
}

export function getUserDefaultSetting() {
  return (dispatch) => {
    dispatch({ type: GET_USER_DEFAULT_SETTINGS_INIT });
    getUserDefaultSettingAPI()
      .then((response) =>
        dispatch({ type: GET_USER_DEFAULT_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_USER_DEFAULT_SETTINGS_FAILED, error })
      );
  };
}

export function createUpdateUserDefaultSetting(body) {
  return (dispatch) => {
    dispatch({ type: SAVE_USER_DEFAULT_SETTINGS_INIT });
    createUpdateUserDefaultSettingAPI(body)
      .then((response) =>
        dispatch({ type: SAVE_USER_DEFAULT_SETTINGS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: SAVE_USER_DEFAULT_SETTINGS_FAILED, error })
      );
  };
}

export function getUserAccessReportChart(body) {
  return (dispatch) => {
    dispatch({ type: GET_USER_ACCESS_CHART_INIT });
    getUserAccessReportChartAPI(body)
      .then((response) =>
        dispatch({ type: GET_USER_ACCESS_CHART_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_USER_ACCESS_CHART_FAILED, error })
      );
  };
}
